import { render, staticRenderFns } from "./DispensationTaskQueue.vue?vue&type=template&id=4c2efb52&scoped=true&"
import script from "./DispensationTaskQueue.vue?vue&type=script&lang=js&"
export * from "./DispensationTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./DispensationTaskQueue.vue?vue&type=style&index=0&id=4c2efb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2efb52",
  null
  
)

export default component.exports